<template>
  <div class="searchCandidate">
    <template
      v-for="item in result"
      :key="item.pointId"
    >
      <NuxtLink
        v-if="item.pointId !== routePointId"
        :to="getPathLink(item.pointId)"
        :external="isExternalLink"
        class="link"
      >
        <p class="city">
          {{ item.point_ja }}
        </p>
        <p class="country">
          {{ item.country_ja }}
        </p>
      </NuxtLink>
      <div
        v-else
        class="link"
        @click="scrollToTop"
      >
        <p class="city">
          {{ item.point_ja }}
        </p>
        <p class="country">
          {{ item.country_ja }}
        </p>
      </div>
    </template>
    <template v-if="result.length === 0">
      <p class="result">
        該当する都市が見つかりませんでした
      </p>
    </template>
  </div>
</template>

<script setup>
const route = useRoute()
const routePointId = route.path

const props = defineProps({
  result: {
    type: Array,
    required: true
  },
  isRadar: {
    type: Boolean,
    required: false,
    default: false
  }
})

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const getPathLink = (pointId) => {
  let relPath = pointId.replace(/^\//, '')
  if (props.isRadar) {
    relPath = `radar/${relPath}`
  }
  return isExternalLink.value ? `${runtimeConfig.app.baseURL}${relPath}` : `/${relPath}`
}
</script>

<style lang="scss" scoped>
.searchCandidate {
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  width: 100%;
  max-height: 450px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.25);
  z-index: 1;
  overflow-y: scroll;
  border-top: solid 1px #D8E0DF;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 100vmax;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #438fec;
  }
  .link {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px 20px 5px 10px;
    cursor: pointer;
    border-bottom: solid 1px #D8E0DF;
    &::after {
      position: absolute;
      top: 50%;
      right: 10px;
      width: 8px;
      height: 8px;
      border-top: solid 2px #303030;
      border-right: solid 2px #303030;
      transform: translateY(-50%) rotate(45deg);
      content: "";
    }
  }
  .city {
    color: #3569c0;
    font-weight: 600;
    line-height: 17px;
  }
  .country {
    color: #303030;
    font-size: 13px;
    line-height: 15px;
  }
  .result {
    padding: 5px 20px 5px 10px;
  }
  @media (any-hover: hover) {
  }
}
.main {
  .searchCandidate {
    @media screen and (min-width: 830px) {
    }
  }
}
</style>
